import * as React from "react";
import { AnyAction } from "redux";
import { useStore, useSelector } from "react-redux";
import { StoreState } from "../models/states/StoreState";
import { PageModel } from "../models/PageModel";
import { startSimulationAsync } from "../simulator/simulatePages";

const pageSelector = (state: StoreState) => state.interview.navigation?.currentPage;

export default function useSimulatedPages() {
    const [simulating, setSimulating] = React.useState(true);
    const [simulatedPages, setSimulatedPages] = React.useState<PageModel[]>([]);
    const currentPage = useSelector(pageSelector);
    const store = useStore<StoreState, AnyAction>();

    React.useEffect(() => {
        setSimulatedPages([]);
        setSimulating(true);

        // Simulate pages asynchronously
        startSimulationAsync(store.getState())
            .then((pages: PageModel[]) => {
                setSimulatedPages(pages);
                setSimulating(false);
            })
            .catch((ex) => {
                if (ex) console.log(ex);
                setSimulating(false);
            });
    }, [store, currentPage]);

    return { simulatedPages, simulating };
}
